import Render from '@Views/components/input/dropdown-editable-indicator/deselect.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class Deselect extends Vue {}